<template>
  <div class="main-card mb-3 card">
    <div class="card-body">
      <h5 class="card-title">Server Parameters</h5>
      <table class="mb-0 table table-bordered">
        <tbody>
          <tr>
            <td>Server Domain/IP</td>
            <td colspan="3">{{ data?.server_domain || '-' }}</td>
          </tr>
          <tr>
            <td>Server identifies the</td>
            <td colspan="3">{{ data?.server_identifies || '-' }}</td>
          </tr>
          <tr>
            <td width="15%">Server OS</td>
            <td width="35%">{{ data?.server_os || '-' }}</td>
            <td width="15%">Web Server</td>
            <td width="35%">{{ data?.web_server || '-' }}</td>
          </tr>
          <tr>
            <td>Server Language</td>
            <td>{{ data?.server_language || '-' }}</td>
            <td>Server Port</td>
            <td>{{ data?.server_port || '-' }}</td>
          </tr>
          <tr>
            <td>Server HostName</td>
            <td>{{ data?.server_hostname || '-' }}</td>
            <td>Absolute Path</td>
            <td>{{ data?.absolute_path || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return this.config
    }
  },
  methods: {
    //
  },
  props: {
    config: Object
  }
}
</script>
